import { Flex } from '@brokerbay/elements-web';
import { Icon, Input } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { isValidEmail } from 'utils';
import VirtualTabContext from './VirtualTabContext';

const VirtualInvitees: React.FC = () => {
  const { invitees, setInvitees } = useContext(VirtualTabContext);

  return (
    <Flex vertical gap="large">
      {invitees.map((invitee, index) => (
        <Flex key={index} vertical gap="small">
          <StyledInput
            data-cy="todo"
            placeholder="Client Name"
            prefix={<Icon type="antdUserOutlined" />}
            value={invitee.name}
            onChange={e => {
              const name = e.target.value;
              setInvitees(prev => {
                const result = [prev[0], prev[1], prev[2]];
                result[index] = { ...result[index], name };
                return result;
              });
            }}
          />
          <StyledInput
            data-cy="todo"
            placeholder="Email"
            prefix={<Icon type="antdMailOutlined" />}
            value={invitee.email}
            onChange={e => {
              const email = e.target.value;
              setInvitees(prev => {
                const result = [prev[0], prev[1], prev[2]];
                result[index] = { ...result[index], email };
                return result;
              });
            }}
            onBlur={() => {
              const { email } = invitees[index];
              const isValid = !email || isValidEmail(email);
              setInvitees(prev => {
                const result = [prev[0], prev[1], prev[2]];
                result[index] = { ...result[index], invalidEmail: !isValid };
                return result;
              });
            }}
            error={invitee.invalidEmail ? 'Invalid email address' : ''}
          />
        </Flex>
      ))}
    </Flex>
  );
};

const StyledInput = styled(Input)`
  && .ant-input {
    padding: 0 8px;
  }
`;

export default VirtualInvitees;
